import { useSelector } from "react-redux";
import EventCard from "./EventCard";
import Noevent from "../../../../Assets/css/Community/NoEvents.webp";

const VolunteerScreen = () => {
    const events = useSelector((state) => state?.community?.events);
    const volunteerEvents = events?.filter(event => event.is_volunteer === true) || [];

    // Helper function to check if event has ended
    const isEventEnded = (endTime) => {
        const now = new Date();
        const eventEndTime = new Date(endTime);
        return eventEndTime < now;
    };

    // Process events to add ended status
    const processedEvents = volunteerEvents.map(event => ({
        ...event,
        is_ended: isEventEnded(event.end_time)
    }));

    return (
        <div>
            {processedEvents?.length > 0 ? (
                processedEvents?.map(event => (
                    <EventCard
                        key={event.id}
                        event={event}
                        className={event.is_ended ? 'event-card-disabled' : ''}
                    />
                ))
            ) : (
                // <div style={{display:"flex", justifyContent:"center"}}>No volunteer events found</div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",  // Centers horizontally
                        justifyContent: "center", // Centers vertically (if needed)
                        textAlign: "center",
                        margin: "auto"
                    }}
                >
                    <img width={"20%"} src={Noevent} alt="No Events" />
                    <h3 style={{ color: "text.secondary", marginTop: "4px" }}>
                        No volunteer events found.
                    </h3>
                </div>
            )}
        </div>
    );
};

export default VolunteerScreen;